import { render, staticRenderFns } from "./kpi-historie.vue?vue&type=template&id=4352e5e3"
import script from "./kpi-historie.vue?vue&type=script&lang=js"
export * from "./kpi-historie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports